var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"header-text":"","button-text":_vm.$t('global.delete')},on:{"action":_vm.deleteItem,"close":function($event){return _vm.$emit('close')}}},[_c('div',{class:_vm.$style.inputContainer},[_vm._v(" "+_vm._s(_vm.output)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }